import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChoiceRow, EntryLayout } from '../../components/EntryLayout';
import { Button } from '../../components/ui/Button';
import { useLocale } from '../../contexts/LocaleContext';
import { useSession } from '../../contexts/SessionContext';
const goalIds = ['health', 'habits', 'fitness', 'performance', 'mental', 'sleep', 'balance'];

/** MOB/Onboarding/Goals — personalization, multi-select. */
export function OnboardingGoals() {
  const {
    t
  } = useLocale();
  const navigate = useNavigate();
  const {
    goals,
    toggleGoal
  } = useSession();
  return <EntryLayout title={t('onb.goals.title')} body={t('onb.goals.body')} step={2} totalSteps={5} footer={<Button variant="gold" size="lg" fullWidth disabled={goals.length === 0} onClick={() => navigate('/onboarding/atividades')} data-id="element-3447" data-mp="1vcqklmfrr6nl">
          {t('onb.continue')}
        </Button>} data-id="element-3446" data-mp="1qgt3vf0lfyaa">
      <ul className="space-y-2" data-id="element-3448" data-mp="3fuev02uuhwrc">
        {goalIds.map(id => <li key={id} data-id="element-3449" data-mp="3aw51dworr47u">
            <ChoiceRow label={t(`onb.goal.${id}`)} selected={goals.includes(id)} onClick={() => toggleGoal(id)} data-id="element-3450" data-mp="3awmwgpzp3ce6" />
          </li>)}
      </ul>
    </EntryLayout>;
}